export default __webpack_public_path__ + "static/media/nosotros-7.695685da.jpg";